<template>
  <span v-html="svgHtml" class="svg-icon"></span>
</template>

<script>
import { SVGICONS } from "@/http/svg-icons"
export default {
  name: "SvgIcon",
  props: {
    iconName: {
      type: String,
      required: true
    }
  },
  computed: {
    svgHtml () {
      return SVGICONS.find(el => el.name === this.iconName)?.svg
    }
  },

}
</script>

<style scoped lang="scss">
  .svg-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>